module.exports = __webpack_public_path__ + "img/in-building.4d19a1eb.png";